export default __webpack_public_path__ + "media/v1/bg-46fa8621.jpg";